/** Defaults y helpers del CMS del sitio público (MoralesBox). */

/** Firma fija de la plataforma (no editable por el cliente). */
export const COPYRIGHT_OWNER = "DanySolutions";

export const DEFAULT_HERO_IMAGE =
  "https://images.pexels.com/photos/6456306/pexels-photo-6456306.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600";

export const DEFAULT_HOME_STATS = [
  { icon: "trophy", value: "12+", label: "Campeones formados" },
  { icon: "users", value: "850+", label: "Atletas activos" },
  { icon: "dumbbell", value: "24/7", label: "Acceso flexible" },
  { icon: "flame", value: "15", label: "Años forjando legados" },
];

export const STAT_ICON_OPTIONS = [
  { id: "trophy", label: "Trofeo" },
  { id: "users", label: "Comunidad" },
  { id: "dumbbell", label: "Pesas" },
  { id: "flame", label: "Fuego" },
  { id: "target", label: "Meta" },
  { id: "zap", label: "Energía" },
  { id: "heart", label: "Corazón" },
  { id: "clock", label: "Reloj" },
];

export const HOME_EDITOR_SECTIONS = [
  { id: "edit-brand", title: "Marca y contacto", description: "Nombre, logo, redes y pie del sitio" },
  { id: "edit-hero", title: "Hero (inicio)", description: "Banner principal y carrusel de fondo" },
  { id: "edit-stats", title: "Estadísticas", description: "Cuatro tarjetas bajo el hero" },
  { id: "edit-packages", title: "Paquetes (home)", description: "Títulos de la sección de membresías" },
  { id: "edit-events", title: "Eventos (home)", description: "Títulos de la sección de combates" },
  { id: "edit-cta", title: "Llamada a la acción", description: "Franja final del inicio" },
  { id: "edit-nav", title: "Navegación", description: "Botones del menú superior" },
  { id: "edit-pages", title: "Páginas internas", description: "Encabezados de contacto, paquetes, productos y eventos" },
];

export const PUBLIC_SITE_FIELD_META = {
  gym_name: { label: "Nombre del gimnasio", hint: "Navbar, footer y título del navegador." },
  logo: { label: "Logotipo", hint: "Imagen en la barra de navegación." },
  address: { label: "Dirección", hint: "Footer y página de contacto." },
  phone: { label: "Teléfono", hint: "Footer y contacto." },
  contact_email: { label: "Correo", hint: "Footer y contacto." },
  footer_blurb: { label: "Texto del pie", hint: "Descripción breve bajo el nombre en el footer." },
  hero_badge: { label: "Etiqueta superior del hero", hint: "Texto pequeño sobre el título principal." },
  hero_title_prefix: { label: "Título — parte 1", hint: "Antes de la palabra destacada." },
  hero_title_highlight: { label: "Título — palabra destacada", hint: "En color rojo." },
  hero_title_suffix: { label: "Título — parte 2", hint: "Después de la palabra destacada." },
  hero_subtitle: { label: "Subtítulo del hero", hint: "Párrafo bajo el título." },
};

export function defaultPublicSite() {
  return {
    gym_name: "BOXING GYM",
    logo: null,
    address: "",
    phone: "",
    contact_email: "",
    footer_blurb: "",
    facebook: "",
    instagram: "",
    twitter: "",
    youtube: "",
    hero_badge: "Desafía tus límites",
    hero_title_prefix: "Forja al",
    hero_title_highlight: "campeón",
    hero_title_suffix: "que llevas dentro",
    hero_subtitle:
      "Entrena con disciplina, suda con propósito. Un gimnasio de boxeo donde cada round te transforma — entrenadores élite, equipo profesional, comunidad real.",
    hero_btn_primary: "Unirse Ahora",
    hero_btn_secondary: "Ver Paquetes",
    hero_btn_contact: "Contacto",
    hero_carousel_interval_sec: 6,
    hero_carousel_slides: [{ type: "image", src: DEFAULT_HERO_IMAGE }],
    home_stats: DEFAULT_HOME_STATS.map((s) => ({ ...s })),
    packages_eyebrow: "Membresías",
    packages_title_prefix: "Elige tu",
    packages_title_highlight: "paquete",
    packages_link_label: "Ver todos",
    popular_badge_label: "Más popular",
    events_eyebrow: "Próximamente",
    events_title_prefix: "Combates",
    events_title_highlight: "en vivo",
    events_link_label: "Ver agenda",
    cta_title_prefix: "¿Listo para el",
    cta_title_highlight: "primer round",
    cta_title_suffix: "?",
    cta_subtitle: "Reserva tu primera clase y descubre por qué somos referente. Sin compromiso, solo sudor.",
    cta_btn_primary: "Reservar clase gratis",
    cta_btn_secondary: "Ver paquetes",
    nav_join_label: "Unirse Ahora",
    nav_login_label: "Login usuario",
    contact_page: { eyebrow: "Contacto", title_prefix: "Hablemos", title_highlight: "cara a cara" },
    packages_page: { eyebrow: "Membresías", title_prefix: "Paquetes &", title_highlight: "promociones" },
    products_page: { eyebrow: "Tienda oficial", title_prefix: "Equipo de", title_highlight: "guerreros" },
    events_page: { eyebrow: "Calendario", title_prefix: "Eventos &", title_highlight: "combates" },
  };
}

export function mergePublicSiteForEditor(raw) {
  const base = defaultPublicSite();
  if (!raw) return base;
  const out = { ...base, ...raw };
  for (const key of ["contact_page", "packages_page", "products_page", "events_page"]) {
    out[key] = { ...base[key], ...(raw[key] || {}) };
  }
  if (Array.isArray(raw.home_stats) && raw.home_stats.length) {
    out.home_stats = raw.home_stats.map((s, i) => ({ ...base.home_stats[i], ...s }));
  }
  if (Array.isArray(raw.hero_carousel_slides) && raw.hero_carousel_slides.length) {
    out.hero_carousel_slides = raw.hero_carousel_slides;
  }
  out.copyright_name = COPYRIGHT_OWNER;
  return out;
}

export function resolvePublicSiteContent(raw) {
  return mergePublicSiteForEditor(raw);
}

export function resolveSiteText(key, site) {
  const s = resolvePublicSiteContent(site);
  const v = s[key];
  if (v === null || v === undefined || v === "") {
    return defaultPublicSite()[key];
  }
  return v;
}

export function resolvePageHeader(pageKey, site) {
  const s = resolvePublicSiteContent(site);
  return s[pageKey] || defaultPublicSite()[pageKey];
}

export function publicSiteToPayload(form) {
  const payload = { ...form };
  delete payload.id;
  delete payload._id;
  return payload;
}

export function dispatchPublicSiteUpdated(detail) {
  window.dispatchEvent(new CustomEvent("public-site-updated", { detail: detail || {} }));
}
